// extracted by mini-css-extract-plugin
export default {"outView":"BusinessCheckStatus_outView__MBS2l","tipText":"BusinessCheckStatus_tipText__pWB6u"};